import { useEffect, useRef } from "react";

const useRenderProductRatings = (productListsData, key) => {
  const renderedIdsRef = useRef(new Set());

  useEffect(() => {
    if (!Array.isArray(productListsData) || productListsData.length === 0) return;

    productListsData.forEach((product, index) => {
      const sku = product.sku?.toUpperCase() || product.SKU?.toUpperCase();
      if (!sku) return;

      const snippetId = `category-snippet-${product.id}${index}${key ? `-${key}` : ""}`;
      const snippetElement = document.getElementById(snippetId);

      if (!snippetElement) return;

      if (renderedIdsRef.current.has(snippetId)) return;

      snippetElement.innerHTML = "";

      renderedIdsRef.current.add(snippetId);

      window.pwr("render", [
        {
          ENABLE_CLIENT_SIDE_STRUCTURED_DATA: false,
          api_key: process.env.NEXT_PUBLIC_POWER_REVIEWS_API_KEY,
          locale: "en_US",
          merchant_group_id: process.env.NEXT_PUBLIC_POWER_REVIEWS_MERCHANT_GROUP_ID,
          merchant_id: process.env.NEXT_PUBLIC_POWER_REVIEWS_MERCHANT_ID,
          page_id: sku,
          components: {
            CategorySnippet: snippetId,
          },
        },
      ]);
    });
  }, [productListsData]);
};

export default useRenderProductRatings;
